import { render, staticRenderFns } from "./CmgSustainabilityErrorBox.vue?vue&type=template&id=c2dafa24&scoped=true&lang=pug"
import script from "./cmg-sustainability-error-box.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-error-box.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityErrorBox.vue?vue&type=style&index=0&id=c2dafa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dafa24",
  null
  
)

export default component.exports